// src/config/suppression.ts
// Centralized semantic suppression collocations (non-interview or risky phrases).
// These DO NOT alter lexical matcher behavior; they are used by semantic-only guards.

export type SuppressionRule = {
  name: string;
  re: RegExp;
};

// Collocations from suppression packs + repro
// Keep patterns tight and explicit to avoid collateral damage.
export const SUPPRESSION_RULES: SuppressionRule[] = [
  { name: "background-check", re: /\bbackground\s+check(s)?\b/i },
  { name: "criminal-background", re: /\bcriminal\s+background\b/i },
  { name: "credit-check", re: /\bcredit\s+check\b/i },
  { name: "metric-system", re: /\bmetric\s+system\b/i },
  { name: "salary-slip", re: /\bsalary\s+(slip|stub|voucher)\b/i },
  { name: "compensation-slip", re: /\bcompensation\s+(slip|stub|voucher)\b/i },
  { name: "project-runway-a", re: /\bproject\s+runway\b/i },
  { name: "project-runway-b", re: /\brunway\s+project\b/i },
  // Topic-level generic that shouldn’t fire Career Goals without 2p context:
  { name: "future-of-work", re: /\bfuture\s+of\s+work\b/i },
];

// Returns the first matching rule, if any
export function matchSuppression(textNorm: string): SuppressionRule | null {
  for (const rule of SUPPRESSION_RULES) {
    if (rule.re.test(textNorm)) return rule;
  }
  return null;
}
